import { findNavigationItemByPath } from "@/common/helpers/breadcrumb";
import { isUuid } from "@/common/helpers/utils";
import { navigationConfig } from "@/config/navigation/navigation.config";

export function resolveParentContext(previousValues: string[]): string | null {
  for (let index = previousValues.length - 1; index >= 0; index--) {
    if (isUuid(previousValues[index])) continue;

    const routePath = `/${previousValues.slice(0, index + 1).join("/")}`;
    const navigationItem = findNavigationItemByPath(navigationConfig, routePath);

    if (navigationItem) return navigationItem.title();
  }

  return null;
}
